import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/i18n";
import { pageHead, contactPageJsonLdScript } from "@/lib/seo";
import { ContactPage } from "@/pages/contact";

export const Route = createFileRoute("/$lang/contact")({
  head: ({ params }) => {
    const lang = (params.lang as "fr" | "en") ?? "fr";
    const t = i18n.getFixedT(lang, "seo");
    const head = pageHead({
      lang,
      pathWithoutLang: "/contact",
      title: t("contact.title"),
      description: t("contact.description"),
    });
    return { ...head, scripts: [contactPageJsonLdScript(lang)] };
  },
  component: ContactPage,
});
